/**
 * kizu-engraving.js
 *
 * Ürün detay sayfasındaki "işlenecek isim" alanını yönetir.
 *
 * Tasarım notları:
 *
 * 1) BOŞ PROPERTY GÖNDERMEME
 *    Shopify, name="properties[...]" alanı boş gelse de sepet satırına boş
 *    bir property ekler. Bunu engellemek için input boşken `name` attribute'u
 *    kaldırılır (disabled yapılamaz, çünkü o zaman kullanıcı yazamaz).
 *    Bu işlem `input` olayında yapılır, submit anında DEĞİL - böylece temanın
 *    kendi FormData oluşturmasıyla yarış durumu oluşmaz.
 *
 * 2) ZORUNLU ALAN DOĞRULAMASI
 *    Asıl koruma input üzerindeki native `required`. Tarayıcı, submit olayı
 *    tetiklenmeden önce doğrulama yapar; bu yüzden Dawn'ın AJAX sepet akışı
 *    da otomatik bloklanır.
 *    Programatik gönderimler (form.requestSubmit / dispatchEvent) native
 *    doğrulamayı atlayabildiği için ek olarak document üzerinde CAPTURE
 *    fazında bir submit dinleyicisi var. Capture, form üzerindeki tema
 *    dinleyicilerinden önce çalışır; böylece gerçekten bloklayabiliriz.
 *
 * 3) VARYANT DEĞİŞİMİ
 *    Dawn varyant değişince buy-buttons bloğunu section rendering ile
 *    yeniden basar ve yazılan değer kaybolur. Değer sessionStorage'da
 *    tutulup connectedCallback'te geri yüklenir.
 */

(function () {
  'use strict';

  if (!window.customElements || customElements.get('kizu-engraving')) return;

  // Harf (tüm diller) + birleşik işaretler + rakam + boşluk + . , ' & -
  var ALLOWED = /^[\p{L}\p{M}0-9 .,'&-]*$/u;
  var CHAR_ERROR =
    "Sadece harf, rakam, boşluk ve . , ' & - karakterlerini kullanabilirsiniz.";

  class KizuEngraving extends HTMLElement {
    constructor() {
      super();
      this.handleInput = this.handleInput.bind(this);
      this.handleSubmitCapture = this.handleSubmitCapture.bind(this);
    }

    connectedCallback() {
      this.input = this.querySelector('[data-kizu-input]');
      if (!this.input) return;

      this.counterEl = this.querySelector('[data-kizu-counter]');
      this.errorEl = this.querySelector('[data-kizu-error]');
      this.previewEl = this.querySelector('[data-kizu-preview]');
      this.previewTextEl = this.querySelector('[data-kizu-preview-text]');

      this.max = parseInt(this.dataset.max, 10) || 20;
      this.isRequired = this.dataset.required === 'true';
      this.propertyAttr = 'properties[' + (this.dataset.property || 'Gravür İsmi') + ']';
      this.storageKey = this.dataset.storageKey || '';

      this.form =
        this.closest('form[action*="/cart/add"]') ||
        this.closest('form[action*="/cart"]') ||
        this.closest('form');

      this.restore();

      this.input.addEventListener('input', this.handleInput);
      this.input.addEventListener('change', this.handleInput);
      document.addEventListener('submit', this.handleSubmitCapture, true);

      this.sync();
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.handleSubmitCapture, true);
      if (this.input) {
        this.input.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('change', this.handleInput);
      }
    }

    /** Fazla boşlukları sadeleştirilmiş, kırpılmış değer. */
    get cleanValue() {
      return (this.input.value || '').replace(/\s+/g, ' ').trim();
    }

    restore() {
      if (!this.storageKey) return;
      try {
        var saved = sessionStorage.getItem(this.storageKey);
        if (saved) this.input.value = saved.slice(0, this.max);
      } catch (e) {
        /* private mode vb. - sessizce yoksay */
      }
    }

    persist() {
      if (!this.storageKey) return;
      try {
        var value = this.cleanValue;
        if (value) sessionStorage.setItem(this.storageKey, value);
        else sessionStorage.removeItem(this.storageKey);
      } catch (e) {
        /* yoksay */
      }
    }

    handleInput() {
      this.sync();
      this.persist();
    }

    /** Sayaç, önizleme, `name` attribute'u ve anlık hata durumunu tazeler. */
    sync() {
      var value = this.cleanValue;

      if (value.length === 0) this.input.removeAttribute('name');
      else this.input.setAttribute('name', this.propertyAttr);

      if (this.counterEl) {
        this.counterEl.textContent = value.length + '/' + this.max;
      }

      if (this.previewEl) {
        this.previewEl.hidden = value.length === 0;
        if (this.previewTextEl) this.previewTextEl.textContent = value;
      }

      if (value.length > 0 && !ALLOWED.test(value)) this.setError(CHAR_ERROR);
      else this.clearError();
    }

    setError(message) {
      this.input.setAttribute('aria-invalid', 'true');
      this.classList.add('kizu-engraving--invalid');
      if (this.errorEl) {
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }
    }

    clearError() {
      this.input.removeAttribute('aria-invalid');
      this.classList.remove('kizu-engraving--invalid');
      if (this.errorEl) {
        this.errorEl.textContent = '';
        this.errorEl.hidden = true;
      }
    }

    validate() {
      var value = this.cleanValue;

      if (this.isRequired && value.length === 0) {
        this.setError('Bu alan zorunlu. Lütfen işlenecek ismi yazın.');
        return false;
      }
      if (value.length > this.max) {
        this.setError('En fazla ' + this.max + ' karakter girebilirsiniz.');
        return false;
      }
      if (value.length > 0 && !ALLOWED.test(value)) {
        this.setError(CHAR_ERROR);
        return false;
      }
      return true;
    }

    handleSubmitCapture(event) {
      if (!this.form || event.target !== this.form) return;

      // Sunucuya kırpılmış değeri gönder.
      if (this.input.value !== this.cleanValue) this.input.value = this.cleanValue;
      this.sync();

      if (this.validate()) return;

      event.preventDefault();
      event.stopPropagation();

      try {
        this.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } catch (e) {
        this.scrollIntoView();
      }
      this.input.focus();
    }
  }

  customElements.define('kizu-engraving', KizuEngraving);
})();
